export const moreAboutPt = {
    title: "Mais sobre a Oilflex",
    sections: [
      {
        subtitle: "A empresa atua em:",
        items: [
          "Consultoria em Gestão Empresarial de Laboratórios;",
          "Tratamento de Dados Físico-Químicos e de Gases Dissolvidos;",
          "Treinamento Profissional;",
          "Educação Tecnológica sob Demanda."
        ]
      },
      {
        subtitle: "Na área de consultoria atuamos com:",
        items: [
          "Apoio na implementação de ensaios de laboratórios para realização de análises físico-químicas e especiais em óleos isolantes, além de análises de gases dissolvidos em óleos isolantes;",
          "Suporte na interpretação e emissão de diagnóstico sobre as condições dos óleos e/ou equipamentos, em função dos resultados obtidos nas análises, com recomendação de ações de manutenção preditiva ou corretiva;",
          "Elaboração de sistema estatístico para acompanhamento dos resultados de análises e de dados históricos, fornecendo ao cliente a situação das condições do óleo e/ou equipamento, com as tendências de comportamento futuro dos equipamentos."
        ]
      },
      {
        subtitle: "Na área de serviços fornecemos suporte nas seguintes soluções:",
        items: [
          "Regeneração de óleo mineral isolante em planta fixa;",
          "Regeneração de óleo mineral isolante com transformadores energizados, na instalação do cliente;",
          "Secagem de óleo mineral isolante e desidratação de parte ativa de transformadores, com utilização de filtros desidratadores;",
          "Descontaminação de óleos minerais isolantes que apresentem enxofre corrosivo, pela retirada de dibenzildissulfeto (DBDS), com retorno ao uso;",
          "Descontaminação de óleos minerais isolantes que possuam bifenilas policloradas – PCB (ascarel), podendo o óleo retornar ao uso, baseando-se na legislação vigente;",
          "Desenvolvimento de processos de regeneração de óleos minerais isolantes, visando atender aos projetos de P&D, ou necessidades específicas do cliente;",
          "Desenvolvimento e implantação de ensaios químicos especiais;",
          "Desenvolvimento de novas metodologias de ensaios físico-químicos;",
          "Elaboração e aplicação de cursos nas áreas de materiais e química;",
          "Criação de ambientes e execução de serviços, projetos e programas de pesquisa;",
          "Avaliações periódicas da qualidade e confiabilidade dos resultados de análises físico-químicas e de gases dissolvidos realizadas no óleo isolante;",
          "Manutenção de laboratórios físico-químicos atualizados em relação a normas e procedimentos vigentes no Brasil;",
          "Treinamento técnico, visando aprimorar os conhecimentos, para emissão de laudos complexos de equipamentos em uso, principalmente quanto a resultados de análises de gases dissolvidos em óleo isolante;",
          "Participação em comparações laboratoriais formais;",
          "Especificação técnica de equipamentos para a realização e implantação de novos ensaios;",
          "Preparação de Procedimentos de Ensaio e Análise (PEA), para ensaios já implantados e novos;",
          "Implantação de laboratório para análises físico-químicas e de gases dissolvidos no óleo isolante;",
          "Implantação da NBR 13882:2021 em laboratório de ensaios físico-químicos;"
        ]
      },
      {
        subtitle: "Na área de Elaboração e Execução de Projetos fornecemos os seguintes suportes:",
        items: [
          "Elaboração e execução de projetos de P&D para atendimento aos requisitos do PEQUI ANEEL;",
          "Projetos para desenvolvimento de sistemas de tratamento e regeneração de líquidos isolantes."
        ]
      }
    ]
  };
  

export const moreAboutEng = {
  title: "More about OILFLEX",
  sections: [
    {
      subtitle: "The company provides:",
      items: [
        "Consulting in Laboratory Business Management;",
        "Treatment of Physicochemical Data and Dissolved Gases Data;",
        "Professional Training;",
        "On-Demand Technological Education."
      ]
    },
    {
      subtitle: "In the consulting area, we operate with:",
      items: [
        "Support in the implementation of laboratory tests for conducting physicochemical and special analyses on insulating oils, as well as analyses of dissolved gases monitoration;",
        "Assistance in interpreting and issuing diagnostics regarding the conditions of oils and/or equipment based on the results obtained from the analyses, with recommendations for predictive or corrective maintenance actions;",
        "Development of a statistical system for monitoring analysis results and historical data, providing the client with the status of oil and/or equipment conditions, along with future behavior trends of the equipment."
      ]
    },
    {
      subtitle: "For service support we have the following solutions:",
      items: [
        "Regeneration of mineral insulating oil in fixed plants;",
        "Regeneration of mineral insulating oil with energized transformers at the client's installation;",
        "Drying of mineral insulating oil and dehydration of the active part of transformers using dehydrating filters;",
        "Decontamination of mineral insulating oils that contain corrosive sulfur by removing dibenzyl disulfide (DBDS), allowing for reuse;",
        "Decontamination of mineral insulating oils containing polychlorinated biphenyls (PCBs) (Askarel), enabling the oil to be reused based on current legislation;",
        "Development of regeneration processes for mineral insulating oils aimed at meeting R&D projects or specific client needs;",
        "Development and implementation of special chemical tests;",
        "Development of new methodologies for physicochemical tests;",
        "Preparation and delivery of courses in the areas of materials and chemistry;",
        "Technical support in creating environments and executing services, projects, and research programs;",
        "Periodic evaluations of the quality and reliability of results from physicochemical and dissolved gas analyses conducted on insulating oil;",
        "Maintenance of physicochemical laboratories updated according to current standards and procedures in Brazil;",
        "Technical training aimed at enhancing knowledge for producing complex reports on equipment in use, especially regarding the results of dissolved gas analyses in insulating oil;",
        "Support for effective participation in formal laboratory comparisons;",
        "Technical specifications for equipment needed to conduct and implement new tests;",
        "Preparation of Testing and Analysis Procedures (TAP) for both established and new tests;",
        "Implementation of a laboratory for physicochemical analyses and dissolved gas evaluations in insulating oil;",
        "Comprehensive support for the implementation of NBR 13882:2021 in physicochemical testing laboratories;",
        "Complete prior support for the implementation of NBR 17025:2017 in physicochemical testing laboratories and dissolved gas analyses in insulating oil for the electric sector."
      ]
    },
    {
      subtitle: "In the area of Project Development and Execution, we provide the following supports:",
      items: [
        "Support for the preparation and execution of R&D projects to meet the requirements of ANEEL's PEQUI;",
        "Projects for the development of treatment and regeneration systems for insulating liquids."
      ]
    }
  ]
};
  